import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=4948605c&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948605c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4948605c')) {
      api.createRecord('4948605c', component.options)
    } else {
      api.reload('4948605c', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=4948605c&scoped=true", function () {
      api.rerender('4948605c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/pages/FormPage.vue"
export default component.exports